<template>
  <div class="AuthorizationSuccess">
    <div class="successBox">
      <div class="successClose" @click="closeWin()">
        关闭
      </div>
      <div class="successImg">
        <img :src="srcImg">
      </div>
      <div class="successTip">
        {{ authResulteText }}
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../config/api'

export default {
  data() {
    return {
      authResulteText: '授权失败',
      srcImg: ''
    }
  },
  created(){
    // let isApplet= this.getUrlParameter('isApplet');
    // if(isApplet === 'true'){
    //   const loading = this.$loading({
    //     lock: true,
    //   });
    //   let authCode = decodeURIComponent(this.getUrlParameter('auth_code'));
    //   let merchantId=this.getUrlParameter('merchant_id');
    //   let expiresIn=this.getUrlParameter('expires_in');
    //
    //   let url=api.system.isAuthSuccess
    //   let data={
    //     authCode,
    //     merchantId,
    //     expiresIn
    //   }
    //   this.$axios.fetchGet(url,data).then((res)=>{
    //     console.log('嗯',res)
    //     loading.close();
    //     if(res.code===200){
    //       this.authResulteText='授权成功';
    //       this.srcImg='../../../../static/success.png';
    //     }else{
    //       this.authResulteText=res.errorMsg;
    //       this.srcImg='../../../../static/error.png';
    //     }
    //   }).catch((error)=>{
    //     loading.close();
    //   })
    // }else{
      console.log('这是公众号返回的授权页面')
      const loading = this.$loading({
        lock: true,
      });
      let authCode = decodeURIComponent(this.getUrlParameter('auth_code'));
      let merchantId=this.getUrlParameter('merchant_id');
      let expiresIn=this.getUrlParameter('expires_in');

      let url=api.system.isAuthSuccess_2;
      let data={
        authCode,
        merchantId,
        expiresIn
      }
      this.$axios.fetchGet(url,data).then((res)=>{
        //console.log('嗯',res)
        loading.close();
        if(res.code===200){
          this.authResulteText='授权成功';
          this.srcImg='../../../../static/success.png';
        }else{
          this.authResulteText=res.errorMsg;
          this.srcImg='../../../../static/error.png';
        }
      }).catch((error)=>{
        loading.close();
      })
    // }
  },
  methods: {
    closeWin() {
      //console.log('aaaaa')
      // window.location.href="about:blank";
      window.close();
    },
    getUrlParameter(str) {
      console.log(window.location.href + '-----------------当前返回的url')
      let url = window.location.href.split('?')[1];
      if (!url) {
        return null;
      }
      let arr1 = url.split('&');
      for (let i in arr1) {
        let arr2 = arr1[i].split('=');
        if (str == arr2[0]) {
          return arr2[1];
        }
      }
      return null;
    }
  }
}
</script>

<style>
.AuthorizationSuccess {
  height: 100%;
  background-color: rgb(241, 241, 241);
  display: flex;
  justify-content: center;
  align-items: center;
}

.AuthorizationSuccess .successBox {
  min-width: 330px;
  height: 330px;
  border: 1px solid #e0e0e4;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 10px;

  font-size: 16px;
}

.AuthorizationSuccess .successBox .successClose {
  text-align: right;
  cursor: pointer;

  color: #666666;
}

.AuthorizationSuccess .successBox .successImg {
  text-align: center;
  margin-top: 50px;
}

.AuthorizationSuccess .successBox .successTip {
  text-align: center;
  margin-top: 30px;

}
</style>



// WEBPACK FOOTER //
// src/page/system/applet/weChatSuccess.vue